import React from "react";
import { CalendarX, Plus, Trash2, Save, Loader2 } from "lucide-react";
import { TopBar } from "@/components/TopBar";
import { http, apiGetPengaturan, formatApiErrorDetail } from "@/lib/api";
import { tanggalIndo } from "@/lib/format";

// A3 (Addendum 3 [PASTI]): Owner and Finance keep the holiday list. Holidays
// and (Owner setting) Sundays are not counted in the planned finish date;
// production, cashier and pick-up still run on those days.
export default function HariLibur() {
  const [cfg, setCfg] = React.useState(null);
  const [libur, setLibur] = React.useState([]);
  const [baru, setBaru] = React.useState("");
  const [busy, setBusy] = React.useState(false);
  const [msg, setMsg] = React.useState(null);

  React.useEffect(() => {
    apiGetPengaturan().then((c) => { setCfg(c); setLibur(c.rencana_hari_libur || []); }).catch((e) => setMsg({ ok: false, text: e.message }));
  }, []);

  const tambah = () => {
    if (!baru || libur.includes(baru)) return;
    setLibur([...libur, baru].sort());
    setBaru("");
  };
  const simpan = async () => {
    setBusy(true);
    setMsg(null);
    try {
      const c = (await http.put("/pengaturan/hari-libur", { rencana_hari_libur: libur })).data;
      setLibur(c.rencana_hari_libur);
      setMsg({ ok: true, text: "Daftar hari libur disimpan (tercatat di audit log)." });
    } catch (e) {
      setMsg({ ok: false, text: formatApiErrorDetail(e.response?.data?.detail) || e.message });
    } finally {
      setBusy(false);
    }
  };
  const berubah = cfg && JSON.stringify(libur) !== JSON.stringify(cfg.rencana_hari_libur || []);

  return (
    <div data-testid="hari-libur-page" className="min-h-screen bg-slate-950 text-slate-200">
      <TopBar />
      <main className="max-w-3xl mx-auto px-4 sm:px-6 py-8 space-y-5">
        <div>
          <h1 className="text-2xl font-bold text-slate-100">Hari Libur</h1>
          <p className="text-sm text-slate-400 mt-1">Tanggal di sini tidak dihitung saat menghitung <b>rencana selesai</b> (waktu produksi dalam hari). Kasir, produksi, dan pengambilan tetap bisa berjalan di hari libur.</p>
        </div>
        {cfg && (
          <p data-testid="hari-libur-minggu" className="text-sm text-slate-300">
            Hari Minggu: <b>{cfg.rencana_lewati_minggu ? "tidak dihitung" : "ikut dihitung"}</b> <span className="text-slate-500">(diatur Owner di Pengaturan)</span>
          </p>
        )}
        <div className="rounded-xl border border-slate-800 bg-slate-900/60 p-4 space-y-3">
          <div className="flex flex-wrap items-end gap-2">
            <label className="text-xs text-slate-400">Tambah tanggal
              <input type="date" data-testid="hari-libur-tanggal" value={baru} onChange={(e) => setBaru(e.target.value)}
                className="mt-1 block rounded-lg border border-slate-700 bg-slate-950 px-3 py-2 text-sm text-slate-100" />
            </label>
            <button type="button" onClick={tambah} data-testid="hari-libur-tambah" disabled={!baru}
              className="inline-flex items-center gap-1.5 rounded-lg border border-slate-600 px-3 py-2 text-sm text-slate-200 disabled:opacity-40"><Plus size={14} /> Tambah</button>
          </div>
          {libur.length === 0 && <p className="text-sm text-slate-500">Belum ada tanggal libur.</p>}
          <ul className="divide-y divide-slate-800">
            {libur.map((t) => (
              <li key={t} data-testid={`hari-libur-${t}`} className="flex items-center justify-between py-2 text-sm">
                <span className="inline-flex items-center gap-2"><CalendarX size={14} className="text-amber-400" /> {tanggalIndo(t)} <span className="font-mono text-xs text-slate-500">{t}</span></span>
                <button type="button" onClick={() => setLibur(libur.filter((x) => x !== t))} aria-label={`Hapus ${t}`}
                  className="text-slate-500 hover:text-red-300"><Trash2 size={14} /></button>
              </li>
            ))}
          </ul>
          <button type="button" onClick={simpan} disabled={busy || !berubah} data-testid="hari-libur-simpan"
            className="inline-flex items-center gap-2 rounded-lg bg-amber-500 px-4 py-2 text-sm font-semibold text-slate-950 disabled:opacity-40">
            {busy ? <Loader2 size={14} className="animate-spin" /> : <Save size={14} />} Simpan
          </button>
          {msg && <p data-testid="hari-libur-msg" className={`text-sm ${msg.ok ? "text-emerald-300" : "text-red-300"}`}>{msg.text}</p>}
        </div>
      </main>
    </div>
  );
}
